import { Small } from '@/components/sv/typographies'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'

export const OverviewFallback = () => (
  <div className="flex flex-col gap-3">
    <div className="flex items-center justify-between">
      <Small className="flex items-center gap-1.5">
        <Skeleton className="h-5.5 w-[32px]" />
        <Skeleton className="h-4 w-[60px]" />
      </Small>
      <Skeleton className="h-4 w-[90px]" />
    </div>
    <Separator />
    <div className="flex items-center justify-between">
      <Small className="flex items-center gap-1">
        <Skeleton className="h-4 w-[60px]" />
      </Small>
      <Skeleton className="h-4 w-[110px]" />
    </div>
    <div className="flex items-center justify-between">
      <Small className="flex items-center gap-1">
        <Skeleton className="h-4 w-[90px]" />
      </Small>
      <Skeleton className="h-4 w-[80px]" />
    </div>
  </div>
)
